/**
 * Auto-grading helpers for production / cloze / listening cards.
 * Compares user input to expected via Levenshtein distance, allowing
 * 1-2 chars of tolerance before downgrading the rating.
 */

export function levenshtein(a: string, b: string): number {
  const m = a.length;
  const n = b.length;
  if (m === 0) return n;
  if (n === 0) return m;
  const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = 0; i <= m; i++) dp[i][0] = i;
  for (let j = 0; j <= n; j++) dp[0][j] = j;
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      if (a[i - 1] === b[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1];
      } else {
        dp[i][j] = 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
      }
    }
  }
  return dp[m][n];
}

export function normalize(s: string): string {
  return s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

export type AutoGrade = "easy" | "good" | "hard" | "again";

export function gradeProduction(expected: string, actual: string): AutoGrade {
  const ne = normalize(expected);
  const na = normalize(actual);
  if (ne === na) return "easy";
  const dist = levenshtein(ne, na);
  if (dist <= 1) return "good";
  if (dist <= 2) return "hard";
  return "again";
}
